export default function AnalyseIcon(props) {
  return (
    <svg
      {...props}
      width='28px'
      height='28px'
      viewBox='0 0 28 28'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g
        id='Page-1'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <g
          id='icon'
          transform='translate(-31.333010, -75.750000)'
          stroke='#3D7BF3'
          strokeWidth='2'
        >
          <g transform='translate(32.583010, 77.000000)' id='Shape'>
            <path d='M9.4392,19.8333 L16.0593,19.8333 M12.75,0 L12.75,1.41667 M21.7657,3.73433 L20.7641,4.73592 M25.5,12.75 L24.0833,12.75 M1.41667,12.75 L0,12.75 M4.73592,4.73592 L3.73433,3.73433 M7.7407,17.7593 C6.7502,16.7686 6.0758,15.5065 5.8026,14.1325 C5.52947,12.7585 5.66986,11.3344 6.206,10.0402 C6.7422,8.746 7.6501,7.6399 8.8149,6.8616 C9.9797,6.0834 11.3491,5.66799 12.75,5.66799 C14.1509,5.66799 15.5203,6.0834 16.6851,6.8616 C17.8499,7.6399 18.7578,8.746 19.294,10.0402 C19.8301,11.3344 19.9705,12.7585 19.6974,14.1325 C19.4242,15.5065 18.7498,16.7686 17.7593,17.7593 L16.983,18.5342 C16.5392,18.9782 16.1871,19.5051 15.947,20.0851 C15.7068,20.6651 15.5833,21.2867 15.5833,21.9144 L15.5833,22.6667 C15.5833,23.4181 15.2848,24.1388 14.7535,24.6701 C14.2221,25.2015 13.5014,25.5 12.75,25.5 C11.9986,25.5 11.2779,25.2015 10.7465,24.6701 C10.2152,24.1388 9.9167,23.4181 9.9167,22.6667 L9.9167,21.9144 C9.9167,20.6465 9.4123,19.4296 8.517,18.5342 L7.7407,17.7593 Z'></path>
          </g>
        </g>
      </g>
    </svg>
  )
}
